import { useEffect } from "react";
import { toast } from "sonner";

interface ToastBridgeProps {
  message: string | null;
}

export function ToastBridge({ message }: ToastBridgeProps) {
  useEffect(() => {
    if (!message) return;
    toast(message, {
      id: "team-notification",
      duration: 2600,
    });
  }, [message]);

  return null;
}
